// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__gyrea","sendOtp":"AuthorizeToLogin_sendOtp__1o5R_"};